
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

interface ConsentOptionProps {
  icon: LucideIcon;
  iconColor: string;
  title: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  isSpecial?: boolean;
}

export const ConsentOption: React.FC<ConsentOptionProps> = ({
  icon: Icon,
  iconColor,
  title,
  description,
  checked,
  disabled = false,
  onChange,
  isSpecial = false
}) => {
  const containerClass = isSpecial 
    ? "bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg border border-purple-200"
    : "bg-gray-50 rounded-lg";

  return (
    <div className={`flex items-center justify-between p-3 ${containerClass}`}>
      <div className="flex items-center space-x-3">
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <div>
          <div className="font-medium text-sm">{title}</div>
          <div className="text-xs text-gray-500">{description}</div>
        </div>
      </div>
      <Switch 
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
    </div>
  );
};
